import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Disruption, DisruptionScenario } from '../../types';
import { api } from '../api';

interface DisruptionsState {
  selectedDisruptionId: string | null;
  selectedScenarioId: string | null;
  filterOptions: {
    type: string | null;
    severity: number | null;
    status: string | null;
    region: string | null;
  };
  sortBy: 'start_date' | 'severity' | 'status';
  sortDirection: 'asc' | 'desc';
}

const initialState: DisruptionsState = {
  selectedDisruptionId: null,
  selectedScenarioId: null,
  filterOptions: {
    type: null,
    severity: null,
    status: null,
    region: null,
  },
  sortBy: 'start_date',
  sortDirection: 'desc',
};

const disruptionsSlice = createSlice({
  name: 'disruptions',
  initialState,
  reducers: {
    selectDisruption: (state, action: PayloadAction<string | null>) => {
      state.selectedDisruptionId = action.payload;
      state.selectedScenarioId = null;
    },
    selectScenario: (state, action: PayloadAction<string | null>) => {
      state.selectedScenarioId = action.payload;
      state.selectedDisruptionId = null;
    },
    setTypeFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.type = action.payload;
    },
    setSeverityFilter: (state, action: PayloadAction<number | null>) => {
      state.filterOptions.severity = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.status = action.payload;
    },
    setRegionFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.region = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'start_date' | 'severity' | 'status'>) => {
      state.sortBy = action.payload;
    },
    setSortDirection: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortDirection = action.payload;
    },
    clearFilters: (state) => {
      state.filterOptions = {
        type: null,
        severity: null,
        status: null,
        region: null,
      };
    },
  },
  extraReducers: (builder) => {
    // Reset selections when disruptions are fetched
    builder.addMatcher(
      api.endpoints.getActiveDisruptions.matchFulfilled,
      (state) => {
        if (!state.selectedDisruptionId) return;
      }
    );
    // Reset selections when scenarios are fetched
    builder.addMatcher(
      api.endpoints.getDisruptionScenarios.matchFulfilled,
      (state) => {
        if (!state.selectedScenarioId) return;
      }
    );
  },
});

export const {
  selectDisruption,
  selectScenario,
  setTypeFilter,
  setSeverityFilter,
  setStatusFilter,
  setRegionFilter,
  setSortBy,
  setSortDirection,
  clearFilters,
} = disruptionsSlice.actions;

export default disruptionsSlice.reducer;
